import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
const scope = ['3 corporate brands: Anzupgo, Adtralza, Spevigo', '5 Master Campaigns built centrally', 'Rolled out across 5 EU5 markets', 'Includes the full Control Tower platform'];
const lines = [{
  label: 'Brand snakification, 3 brands',
  detail: 'Master brand builds, reused by every market',
  value: '€66,000'
}, {
  label: '5 Master Snak campaigns',
  detail: 'Central creative build, €3,000 each',
  value: '€15,000'
}, {
  label: 'EU5 web localization',
  detail: '3 brands × 5 markets × €2,000',
  value: '€30,000'
}, {
  label: 'Local campaign adaptation',
  detail: '5 campaigns × 5 markets × €1,000',
  value: '€25,000'
}, {
  label: 'Control Tower platform',
  detail: '12-month license and governance hub',
  value: '€50,000'
}, {
  label: 'EU5 activation, 12 months',
  detail: '25 campaign markets × €99 per month',
  value: '€29,700'
}, {
  label: 'Dedicated LEO team',
  detail: 'Programme management and optimization, 12 months',
  value: '€35,000'
}];
export function OptionADetail() {
  return <div data-id="element-75" data-mp="3tmz6vrb5bjxq">
      <p className="text-[clamp(0.95rem,1.3vw,1.3rem)] font-semibold leading-snug text-[var(--fg)]" data-id="element-76" data-mp="3tqmyum0xzyac">
        A comprehensive test of the centralized hub model across the most
        critical legacy brands, lifting assets you already own rather than
        adding a net new programme.
      </p>

      <ul className="mt-5 grid grid-cols-2 gap-x-6 gap-y-2" data-id="element-77" data-mp="lal7eku1trkq">
        {scope.map(item => <li key={item} className="flex items-start gap-3" data-id="element-78" data-mp="gbgvhmfqpfqp">
            <ArrowRightIcon className="mt-1 h-4 w-4 flex-shrink-0 text-[var(--brand-green-light)]" aria-hidden="true" data-id="element-79" data-mp="bhm6q4la2akr" />
            <span className="text-[clamp(0.85rem,1.05vw,1.05rem)] leading-relaxed text-[var(--muted)]" data-id="element-80" data-mp="13yyjd6vvvtoe">
              {item}
            </span>
          </li>)}
      </ul>

      <div className="mt-6" data-id="element-81" data-mp="z65fel88opdd">
        {lines.map(line => <div key={line.label} className="flex items-baseline justify-between gap-6 border-b border-black/10 py-3" data-id="element-82" data-mp="2thevqk3areaa">
            <div data-id="element-83" data-mp="2jqagdj9plrex">
              <p className="text-[clamp(0.85rem,1.05vw,1.05rem)] font-semibold leading-tight text-[var(--fg)]" data-id="element-84" data-mp="2jqu117qqutwn">
                {line.label}
              </p>
              <p className="text-[clamp(0.72rem,0.9vw,0.9rem)] leading-tight text-[var(--muted)]" data-id="element-85" data-mp="2onam1t2ncs5i">
                {line.detail}
              </p>
            </div>
            <span className="flex-shrink-0 text-[clamp(1rem,1.4vw,1.4rem)] font-bold leading-none text-[var(--fg)]" data-id="element-86" data-mp="2fpgtmt806inm">
              {line.value}
            </span>
          </div>)}
      </div>

      <div className="mt-5 flex items-center justify-between gap-6 rounded-2xl bg-[var(--brand-green)] px-6 py-4 text-white" data-id="element-87" data-mp="25rarqbm75cir">
        <div data-id="element-88" data-mp="3v3cxqgjmul05">
          <p className="text-[clamp(0.7rem,0.9vw,0.9rem)] font-bold uppercase tracking-wider text-[var(--brand-green-lighter)]" data-id="element-89" data-mp="3v3mquczz58a2">
            Total investment
          </p>
          <p className="mt-1 text-[clamp(0.78rem,0.95vw,0.95rem)] text-white/70" data-id="element-90" data-mp="1ohgmv3tbcpf0">
            Every later market inherits this build at marginal cost.
          </p>
        </div>
        <p className="flex-shrink-0 text-[clamp(1.6rem,2.6vw,2.6rem)] font-bold leading-none" data-id="element-91" data-mp="1y81rb7vo4o5u">
          €250,700
        </p>
      </div>
    </div>;
}